import { render, staticRenderFns } from "./complaintBack.vue?vue&type=template&id=7522f4d2&scoped=true"
import script from "./complaintBack.vue?vue&type=script&lang=js"
export * from "./complaintBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522f4d2",
  null
  
)

export default component.exports